module.exports = __webpack_public_path__ + "img/maintenance.02544fb0.png";